import { render, staticRenderFns } from "./JobInfo.vue?vue&type=template&id=216e3f34&scoped=true"
import script from "./JobInfo.vue?vue&type=script&lang=js"
export * from "./JobInfo.vue?vue&type=script&lang=js"
import style0 from "./JobInfo.vue?vue&type=style&index=0&id=216e3f34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e3f34",
  null
  
)

export default component.exports